import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import LeftArrow from '../../../../assets/images/left-arrow.svg'
import { getControlNumber } from '../../../../Utils/Utility';
import { injectIntl } from 'react-intl';

function BilledHeader({intl,...props}) {
    const user = useSelector(state => state.amplifyUser.user);
    const { formatMessage } = intl;
    const controlNumber = getControlNumber();

    return (
        <div className="top_header_bar">
            <div className="row">
                <div className="col-sm col-xl-4 d-flex align-items-center p-0">
                    <Link to={{ pathname: props.path, state: { amount: props.amount, remainingAmount: props.remainingAmount, selection: props.selection, total_bill_amount: props.total_bill_amount, paymentmethods: props.paymentmethods, tin: props.tin } }} className="text-dark" style={{ marginRight: '15px' }}>
                        <img src={LeftArrow} className="bakc-arrow" />
                    </Link>
                    <h3 className="m-0 h3-heading" title={controlNumber ? controlNumber : ''}> {controlNumber ? controlNumber : ''}
                        <br />
                        <label className="header-subtitle" title="Billed">{formatMessage({ id: "app.payment_due_header" })}</label>
                    </h3>
                </div>

            </div>
        </div>
    )
}

export default injectIntl(BilledHeader);
